<template>
  <div style="margin: 4vh 10vw; width: 80vw; ">
    <h1 style="font-weight: bolder; font-size: 30px">Our Team</h1>
    <p class="detail_page">Based on years of in-depth assessments of numerous companies in different industries,</p>
    <p class="detail_page">we are willing to provide our portfolio companies with great assistance to accelerate
      post-investment performance.</p>
    <p class="detail_page">SIG is dedicated to helping our entrepreneurs build successful companies by providing them
      with capital, guidance, network and the best resources available.</p>
  </div>
  <Team_manager_adviser_bar_en></Team_manager_adviser_bar_en>
  <router-view></router-view>

</template>

<script>
import Team_manager_adviser_bar_en from "@/components/EN/team/Team_manager_adviser_bar_en";

export default {
  name: 'Team_manager_adviser_en',
  components: {Team_manager_adviser_bar_en,}
}

</script>

<style scoped>
.detail_page {
  color: black;
  white-space: pre-wrap;
  margin: 0.5vh 10vh;
  font-size: 14px;

}
</style>